/**
 * ngbms-rostering
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Shift } from './shift';
import { Identity } from './identity';
import { Contact } from './contact';


/**
 * 
 */
export interface Driver { 
    /**
     * 
     */
    userid?: string;
    /**
     * 
     */
    full_name?: string;
    /**
     * 
     */
    family_name?: string;
    /**
     * 
     */
    middle_name?: string;
    identification?: Identity;
    /**
     * Stores the contact number(s) of the driver. Although this is an array, current version only allows for one contact and the first contact will be used if more than one is provided. The array structure allows for future flexibilty to add in additional numbers
     */
    contact_numbers?: Array<Contact>;
    /**
     * 
     */
    country_code?: string;
    /**
     * 
     */
    status?: Driver.StatusEnum;
    /**
     * Joining date. Upon creation of new driver, if this field is empty, then the current date/time is used.
     */
    date_joined?: string;
    /**
     * 
     */
    residential_address?: string;
    /**
     * 
     */
    mailing_address?: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * List of shifts that the driver can be assigned work.
     */
    available_shifts?: Array<Shift>;
    /**
     * The list of days that the driver is on leave and cannot be assigned duties.
     */
    planned_leaves?: Array<string>;
}
export namespace Driver {
    export type StatusEnum = 'ACTIVE' | 'DELETED' | 'SUSPENDED' | 'ONLEAVE' | 'DISMISSED' | 'RESIGNED' | 'MEDICAL_LEAVE';
    export const StatusEnum = {
        Active: 'ACTIVE' as StatusEnum,
        Deleted: 'DELETED' as StatusEnum,
        Suspended: 'SUSPENDED' as StatusEnum,
        Onleave: 'ONLEAVE' as StatusEnum,
        Dismissed: 'DISMISSED' as StatusEnum,
        Resigned: 'RESIGNED' as StatusEnum,
        MedicalLeave: 'MEDICAL_LEAVE' as StatusEnum
    };
}


